import React, { useState, useEffect } from 'react';

function SchnitzeljagdManager() {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [termine, setTermine] = useState([]);
  const [selectedTermin, setSelectedTermin] = useState(null);
  const [buchungen, setBuchungen] = useState([]);
  const [alleBuchungen, setAlleBuchungen] = useState([]);
  const [activeTab, setActiveTab] = useState('events');
  const [loading, setLoading] = useState(true);
  const [showEventForm, setShowEventForm] = useState(false);
  const [showTerminForm, setShowTerminForm] = useState(false);
  const [eventForm, setEventForm] = useState({
    title: '',
    description: '',
    start_date: '',
    end_date: '',
    max_participants_per_day: 20,
    price: 0,
    location: 'Futurhinos for Kids, Gottlieb-Daimler-Str. 36'
  });
  const [terminForm, setTerminForm] = useState({
    date: '',
    start_time: '10:00',
    end_time: '16:00',
    max_participants: 20
  });

  // Feedback states
  const [feedbackEventId, setFeedbackEventId] = useState(null);
  const [feedbackUrl, setFeedbackUrl] = useState('https://forms.office.com/pages/responsepage.aspx?id=dLBAFHm2gE6ub1gm7fZOidYFGAcLjuxGto0EDktiXZRUQUVCU1lNQ01NN1lCTFRKRzFNWlpDMzUwVC4u&route=shorturl');
  const [excludedEmails, setExcludedEmails] = useState(new Set());
  const [feedbackSending, setFeedbackSending] = useState(false);
  const [feedbackSuccess, setFeedbackSuccess] = useState('');
  const [feedbackError, setFeedbackError] = useState('');

  useEffect(() => {
    fetchEvents();
    fetchAlleBuchungen();
  }, []);

  useEffect(() => {
    if (selectedEvent) {
      fetchTermine(selectedEvent.id);
    }
  }, [selectedEvent]);

  useEffect(() => {
    if (selectedTermin) {
      fetchBuchungen(selectedTermin.id);
    }
  }, [selectedTermin]);

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/schnitzeljagd/events');
      const data = await res.json();
      setEvents(data.data || []);
    } catch (err) {
      console.error('Fehler:', err);
    }
    setLoading(false);
  };

  const fetchAlleBuchungen = async () => {
    try {
      const res = await fetch('/api/schnitzeljagd/buchungen');
      const data = await res.json();
      setAlleBuchungen(data.data || []);
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const fetchTermine = async (eventId) => {
    try {
      const res = await fetch(`/api/schnitzeljagd/events/${eventId}/termine`);
      const data = await res.json();
      setTermine(data.data || []);
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const fetchBuchungen = async (terminId) => {
    try {
      const res = await fetch(`/api/schnitzeljagd/termine/${terminId}/buchungen`);
      const data = await res.json();
      setBuchungen(data.data || []);
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const handleSaveEvent = async (e) => {
    e.preventDefault();
    try {
      const method = eventForm.id ? 'PUT' : 'POST';
      const url = eventForm.id
        ? `/api/schnitzeljagd/events/${eventForm.id}`
        : '/api/schnitzeljagd/events';

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(eventForm)
      });

      if (res.ok) {
        fetchEvents();
        setShowEventForm(false);
        setEventForm({
          title: '',
          description: '',
          start_date: '',
          end_date: '',
          max_participants_per_day: 20,
          price: 0,
          location: 'Futurhinos for Kids, Gottlieb-Daimler-Str. 36'
        });
      }
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const handleDeleteEvent = async (id) => {
    if (!window.confirm('Event wirklich loeschen? Alle Termine und Buchungen werden ebenfalls geloescht!')) return;

    try {
      await fetch(`/api/schnitzeljagd/events/${id}`, { method: 'DELETE' });
      fetchEvents();
      setSelectedEvent(null);
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const handleSaveTermin = async (e) => {
    e.preventDefault();
    try {
      const method = terminForm.id ? 'PUT' : 'POST';
      const url = terminForm.id
        ? `/api/schnitzeljagd/termine/${terminForm.id}`
        : `/api/schnitzeljagd/events/${selectedEvent.id}/termine`;

      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(terminForm)
      });

      if (res.ok) {
        fetchTermine(selectedEvent.id);
        setShowTerminForm(false);
        setTerminForm({
          date: '',
          start_time: '10:00',
          end_time: '16:00',
          max_participants: 20
        });
      }
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const handleDeleteTermin = async (id) => {
    if (!window.confirm('Termin wirklich loeschen? Alle Buchungen werden ebenfalls geloescht!')) return;

    try {
      await fetch(`/api/schnitzeljagd/termine/${id}`, { method: 'DELETE' });
      fetchTermine(selectedEvent.id);
      setSelectedTermin(null);
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const handleDeleteBuchung = async (id) => {
    if (!window.confirm('Buchung wirklich loeschen?')) return;

    try {
      await fetch(`/api/schnitzeljagd/buchungen/${id}`, { method: 'DELETE' });
      fetchBuchungen(selectedTermin.id);
      fetchTermine(selectedEvent.id);
    } catch (err) {
      console.error('Fehler:', err);
    }
  };

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString('de-DE', {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary"></div>
      </div>
    );
  }

  // Buchungen-Ansicht
  if (selectedTermin) {
    return (
      <div>
        <button className="btn btn-outline-secondary mb-3" onClick={() => setSelectedTermin(null)}>
          &larr; Zurueck zu Terminen
        </button>

        <div className="card mb-4">
          <div className="card-header">
            <h5 className="mb-0">
              Buchungen fuer {formatDate(selectedTermin.date)}
              <span className="badge bg-info ms-2">
                {buchungen.length} / {selectedTermin.max_participants} Familien
              </span>
            </h5>
          </div>
          <div className="card-body">
            {buchungen.length === 0 ? (
              <p className="text-muted">Noch keine Buchungen fuer diesen Termin.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Familie</th>
                      <th>E-Mail</th>
                      <th>Telefon</th>
                      <th>Personen</th>
                      <th>Alter Kinder</th>
                      <th>Nachricht</th>
                      <th>Angemeldet</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {buchungen.map(b => (
                      <tr key={b.id}>
                        <td><strong>{b.family_name}</strong></td>
                        <td>{b.email}</td>
                        <td>{b.phone || '-'}</td>
                        <td>{b.adults} Erw. + {b.children} Kind(er)</td>
                        <td>{b.children_ages || '-'}</td>
                        <td>{b.message || '-'}</td>
                        <td>{new Date(b.created_at).toLocaleDateString('de-DE')}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary me-1"
                            onClick={async () => {
                              try {
                                const res = await fetch(`/api/schnitzeljagd/buchungen/${b.id}/resend-confirmation`, { method: 'POST' });
                                const data = await res.json();
                                if (data.message === 'success') {
                                  alert('E-Mail wurde erneut gesendet!');
                                } else {
                                  alert('Fehler: ' + (data.error || 'E-Mail konnte nicht gesendet werden'));
                                }
                              } catch (err) {
                                alert('Fehler beim Senden');
                              }
                            }}
                          >
                            E-Mail
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDeleteBuchung(b.id)}
                          >
                            Loeschen
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Termine-Ansicht
  if (selectedEvent) {
    return (
      <div>
        <button className="btn btn-outline-secondary mb-3" onClick={() => setSelectedEvent(null)}>
          &larr; Zurueck zu Events
        </button>

        <div className="card mb-4">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">{selectedEvent.title}</h5>
            <button
              className="btn btn-primary btn-sm"
              onClick={() => {
                setTerminForm({
                  date: '',
                  start_time: '10:00',
                  end_time: '16:00',
                  max_participants: selectedEvent.max_participants_per_day || 20
                });
                setShowTerminForm(true);
              }}
            >
              + Termin hinzufuegen
            </button>
          </div>
          <div className="card-body">
            <p className="text-muted">
              {selectedEvent.start_date} bis {selectedEvent.end_date} | Max. {selectedEvent.max_participants_per_day} Familien/Tag
            </p>

            {showTerminForm && (
              <div className="card bg-light mb-4">
                <div className="card-body">
                  <h6>{terminForm.id ? 'Termin bearbeiten' : 'Neuer Termin'}</h6>
                  <form onSubmit={handleSaveTermin}>
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label className="form-label">Datum</label>
                        <input
                          type="date"
                          className="form-control"
                          value={terminForm.date}
                          onChange={e => setTerminForm({ ...terminForm, date: e.target.value })}
                          required
                        />
                      </div>
                      <div className="col-md-2 mb-3">
                        <label className="form-label">Start</label>
                        <input
                          type="time"
                          className="form-control"
                          value={terminForm.start_time}
                          onChange={e => setTerminForm({ ...terminForm, start_time: e.target.value })}
                        />
                      </div>
                      <div className="col-md-2 mb-3">
                        <label className="form-label">Ende</label>
                        <input
                          type="time"
                          className="form-control"
                          value={terminForm.end_time}
                          onChange={e => setTerminForm({ ...terminForm, end_time: e.target.value })}
                        />
                      </div>
                      <div className="col-md-2 mb-3">
                        <label className="form-label">Max. Familien</label>
                        <input
                          type="number"
                          className="form-control"
                          value={terminForm.max_participants}
                          onChange={e => setTerminForm({ ...terminForm, max_participants: parseInt(e.target.value) })}
                          min="1"
                        />
                      </div>
                      <div className="col-md-3 mb-3 d-flex align-items-end gap-2">
                        <button type="submit" className="btn btn-success">Speichern</button>
                        <button type="button" className="btn btn-secondary" onClick={() => setShowTerminForm(false)}>Abbrechen</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {termine.length === 0 ? (
              <p className="text-muted">Noch keine Termine angelegt.</p>
            ) : (
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Datum</th>
                      <th>Zeit</th>
                      <th>Buchungen</th>
                      <th>Status</th>
                      <th>Aktionen</th>
                    </tr>
                  </thead>
                  <tbody>
                    {termine.map(t => {
                      const booked = parseInt(t.booked_count) || 0;
                      const isFull = booked >= t.max_participants;

                      return (
                        <tr key={t.id}>
                          <td><strong>{formatDate(t.date)}</strong></td>
                          <td>{t.start_time} - {t.end_time}</td>
                          <td>
                            <span className={`badge ${isFull ? 'bg-danger' : 'bg-success'}`}>
                              {booked} / {t.max_participants}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${t.active ? 'bg-success' : 'bg-secondary'}`}>
                              {t.active ? 'Aktiv' : 'Inaktiv'}
                            </span>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-outline-primary me-1"
                              onClick={() => setSelectedTermin(t)}
                            >
                              Buchungen
                            </button>
                            {booked > 0 && (
                              <button
                                className="btn btn-sm btn-outline-warning me-1"
                                onClick={async () => {
                                  if (!window.confirm(`Erinnerungs-E-Mail an alle ${booked} Familien dieses Termins senden?`)) return;
                                  try {
                                    const res = await fetch(`/api/schnitzeljagd/termine/${t.id}/send-reminder`, { method: 'POST' });
                                    const data = await res.json();
                                    if (data.message === 'success') {
                                      alert(`Erinnerungen versendet!\n${data.sent} erfolgreich, ${data.failed} fehlgeschlagen`);
                                    } else {
                                      alert('Fehler: ' + (data.error || 'Unbekannter Fehler'));
                                    }
                                  } catch (err) {
                                    alert('Fehler beim Senden');
                                  }
                                }}
                              >
                                Erinnerung
                              </button>
                            )}
                            <button
                              className="btn btn-sm btn-outline-secondary me-1"
                              onClick={() => {
                                setTerminForm({
                                  id: t.id,
                                  date: t.date,
                                  start_time: t.start_time,
                                  end_time: t.end_time,
                                  max_participants: t.max_participants,
                                  active: t.active
                                });
                                setShowTerminForm(true);
                              }}
                            >
                              Bearbeiten
                            </button>
                            <button
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => handleDeleteTermin(t.id)}
                            >
                              Loeschen
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Events-Uebersicht
  return (
    <div>
      <h4>Schnitzeljagd verwalten</h4>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'events' ? 'active' : ''}`}
            onClick={() => setActiveTab('events')}
          >
            Events ({events.length})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'anmeldungen' ? 'active' : ''}`}
            onClick={() => setActiveTab('anmeldungen')}
          >
            Alle Anmeldungen ({alleBuchungen.length})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'feedback' ? 'active' : ''}`}
            onClick={() => setActiveTab('feedback')}
          >
            Feedback senden
          </button>
        </li>
      </ul>

      {/* Anmeldungen Tab */}
      {activeTab === 'anmeldungen' && (
        <>
          {alleBuchungen.length === 0 ? (
            <div className="alert alert-info">
              Noch keine Anmeldungen vorhanden.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Termin</th>
                    <th>Familie</th>
                    <th>Kontakt</th>
                    <th>Teilnehmer</th>
                    <th>Alter Kinder</th>
                    <th>Nachricht</th>
                    <th>Angemeldet</th>
                    <th>Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                  {alleBuchungen.map(b => (
                    <tr key={b.id}>
                      <td>
                        {formatDate(b.termin_date)}<br />
                        <small className="text-muted">{b.start_time} - {b.end_time}</small>
                      </td>
                      <td><strong>{b.family_name}</strong></td>
                      <td>
                        <a href={`mailto:${b.email}`}>{b.email}</a>
                        {b.phone && <><br /><small>{b.phone}</small></>}
                      </td>
                      <td>{b.adults} Erw. + {b.children} Kind(er)</td>
                      <td>{b.children_ages || '-'}</td>
                      <td><small>{b.message || '-'}</small></td>
                      <td>{new Date(b.created_at).toLocaleDateString('de-DE')}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={async () => {
                            try {
                              const res = await fetch(`/api/schnitzeljagd/buchungen/${b.id}/resend-confirmation`, { method: 'POST' });
                              const data = await res.json();
                              if (data.message === 'success') {
                                alert('E-Mail wurde erneut gesendet!');
                              } else {
                                alert('Fehler: ' + (data.error || 'E-Mail konnte nicht gesendet werden'));
                              }
                            } catch (err) {
                              alert('Fehler beim Senden');
                            }
                          }}
                        >
                          E-Mail
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={async () => {
                            if (!window.confirm('Buchung wirklich löschen?')) return;
                            try {
                              await fetch(`/api/schnitzeljagd/buchungen/${b.id}`, { method: 'DELETE' });
                              fetchAlleBuchungen();
                            } catch (err) {
                              console.error('Fehler:', err);
                            }
                          }}
                        >
                          Löschen
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* Feedback Tab */}
      {activeTab === 'feedback' && (
        <div>
          {feedbackSuccess && <div className="alert alert-success">{feedbackSuccess}</div>}
          {feedbackError && <div className="alert alert-danger">{feedbackError}</div>}

          <div className="card mb-4">
            <div className="card-header">
              <h5 className="mb-0">Feedback-E-Mail konfigurieren</h5>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Event auswaehlen *</label>
                <select
                  className="form-select"
                  value={feedbackEventId || ''}
                  onChange={e => {
                    setFeedbackEventId(e.target.value ? parseInt(e.target.value) : null);
                    setExcludedEmails(new Set());
                  }}
                >
                  <option value="">-- Event waehlen --</option>
                  {events.map(ev => (
                    <option key={ev.id} value={ev.id}>{ev.title}</option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="form-label">Link zum Feedbackbogen *</label>
                <input
                  type="url"
                  className="form-control"
                  value={feedbackUrl}
                  onChange={e => setFeedbackUrl(e.target.value)}
                  placeholder="https://forms.office.com/..."
                />
              </div>
            </div>
          </div>

          {feedbackEventId && (
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                <span>
                  Empfaenger auswaehlen
                  {(() => {
                    const eventBuchungen = alleBuchungen.filter(b => {
                      const eventForBuchung = events.find(e => e.id === feedbackEventId);
                      return eventForBuchung && b.event_title === eventForBuchung.title;
                    });
                    const uniqueEmails = [...new Set(eventBuchungen.map(b => b.email))];
                    const selectedCount = uniqueEmails.filter(email => !excludedEmails.has(email)).length;
                    return ` (${selectedCount} von ${uniqueEmails.length} ausgewaehlt)`;
                  })()}
                </span>
                <div className="btn-group btn-group-sm">
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => setExcludedEmails(new Set())}
                  >
                    Alle auswaehlen
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={() => {
                      const eventBuchungen = alleBuchungen.filter(b => {
                        const eventForBuchung = events.find(e => e.id === feedbackEventId);
                        return eventForBuchung && b.event_title === eventForBuchung.title;
                      });
                      const allEmails = [...new Set(eventBuchungen.map(b => b.email))];
                      setExcludedEmails(new Set(allEmails));
                    }}
                  >
                    Keine auswaehlen
                  </button>
                </div>
              </div>
              <div className="card-body p-0">
                <table className="table table-striped mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: '40px' }}>Senden</th>
                      <th>Familie</th>
                      <th>E-Mail</th>
                      <th>Termin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(() => {
                      const eventBuchungen = alleBuchungen.filter(b => {
                        const eventForBuchung = events.find(e => e.id === feedbackEventId);
                        return eventForBuchung && b.event_title === eventForBuchung.title;
                      });
                      // Deduplizieren nach E-Mail
                      const uniqueByEmail = [];
                      const seenEmails = new Set();
                      for (const b of eventBuchungen) {
                        if (!seenEmails.has(b.email)) {
                          seenEmails.add(b.email);
                          uniqueByEmail.push(b);
                        }
                      }
                      return uniqueByEmail.map(b => {
                        const isExcluded = excludedEmails.has(b.email);
                        return (
                          <tr key={b.email} className={isExcluded ? 'table-secondary' : ''}>
                            <td>
                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={!isExcluded}
                                onChange={() => {
                                  setExcludedEmails(prev => {
                                    const newSet = new Set(prev);
                                    if (newSet.has(b.email)) {
                                      newSet.delete(b.email);
                                    } else {
                                      newSet.add(b.email);
                                    }
                                    return newSet;
                                  });
                                }}
                              />
                            </td>
                            <td className={isExcluded ? 'text-muted' : ''}>{b.family_name}</td>
                            <td className={isExcluded ? 'text-muted' : ''}>{b.email}</td>
                            <td className={isExcluded ? 'text-muted' : ''}>
                              {new Date(b.termin_date).toLocaleDateString('de-DE')}
                            </td>
                          </tr>
                        );
                      });
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {feedbackEventId && (
            <button
              className="btn btn-success btn-lg"
              disabled={feedbackSending || !feedbackUrl || (() => {
                const eventBuchungen = alleBuchungen.filter(b => {
                  const eventForBuchung = events.find(e => e.id === feedbackEventId);
                  return eventForBuchung && b.event_title === eventForBuchung.title;
                });
                const uniqueEmails = [...new Set(eventBuchungen.map(b => b.email))];
                const selectedCount = uniqueEmails.filter(email => !excludedEmails.has(email)).length;
                return selectedCount === 0;
              })()}
              onClick={async () => {
                const eventBuchungen = alleBuchungen.filter(b => {
                  const eventForBuchung = events.find(e => e.id === feedbackEventId);
                  return eventForBuchung && b.event_title === eventForBuchung.title;
                });
                const uniqueEmails = [...new Set(eventBuchungen.map(b => b.email))];
                const selectedCount = uniqueEmails.filter(email => !excludedEmails.has(email)).length;

                if (!window.confirm(`Feedback-E-Mail an ${selectedCount} Empfaenger senden?`)) return;

                setFeedbackSending(true);
                setFeedbackSuccess('');
                setFeedbackError('');

                try {
                  const res = await fetch(`/api/schnitzeljagd/events/${feedbackEventId}/send-feedback`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      feedbackUrl,
                      excludedEmails: [...excludedEmails]
                    })
                  });
                  const data = await res.json();
                  if (data.message === 'success') {
                    setFeedbackSuccess(`Feedback-E-Mails versendet! ${data.sent} erfolgreich, ${data.failed} fehlgeschlagen`);
                  } else {
                    setFeedbackError(data.error || 'Unbekannter Fehler');
                  }
                } catch (err) {
                  setFeedbackError('Fehler beim Senden');
                }
                setFeedbackSending(false);
              }}
            >
              {feedbackSending ? 'Wird gesendet...' : (() => {
                const eventBuchungen = alleBuchungen.filter(b => {
                  const eventForBuchung = events.find(e => e.id === feedbackEventId);
                  return eventForBuchung && b.event_title === eventForBuchung.title;
                });
                const uniqueEmails = [...new Set(eventBuchungen.map(b => b.email))];
                const selectedCount = uniqueEmails.filter(email => !excludedEmails.has(email)).length;
                return `Feedback-E-Mail jetzt senden (${selectedCount})`;
              })()}
            </button>
          )}
        </div>
      )}

      {/* Events Tab */}
      {activeTab === 'events' && (
        <>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <span></span>
          <button
          className="btn btn-primary"
          onClick={() => {
            setEventForm({
              title: 'Oster-Schnitzeljagd Schorndorf 2026',
              description: 'Hybride Familien-Aktion durch die Altstadt mit 10 Stationen',
              start_date: '2026-03-21',
              end_date: '2026-04-04',
              max_participants_per_day: 20,
              price: 0,
              location: 'Futurhinos for Kids, Gottlieb-Daimler-Str. 36'
            });
            setShowEventForm(true);
          }}
        >
          + Neues Event
        </button>
      </div>

      {showEventForm && (
        <div className="card mb-4">
          <div className="card-header">
            <h5 className="mb-0">{eventForm.id ? 'Event bearbeiten' : 'Neues Event'}</h5>
          </div>
          <div className="card-body">
            <form onSubmit={handleSaveEvent}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Titel *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={eventForm.title}
                    onChange={e => setEventForm({ ...eventForm, title: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Startort</label>
                  <input
                    type="text"
                    className="form-control"
                    value={eventForm.location}
                    onChange={e => setEventForm({ ...eventForm, location: e.target.value })}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Beschreibung</label>
                <textarea
                  className="form-control"
                  rows="2"
                  value={eventForm.description}
                  onChange={e => setEventForm({ ...eventForm, description: e.target.value })}
                />
              </div>

              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Startdatum *</label>
                  <input
                    type="date"
                    className="form-control"
                    value={eventForm.start_date}
                    onChange={e => setEventForm({ ...eventForm, start_date: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Enddatum *</label>
                  <input
                    type="date"
                    className="form-control"
                    value={eventForm.end_date}
                    onChange={e => setEventForm({ ...eventForm, end_date: e.target.value })}
                    required
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Max. Familien/Tag</label>
                  <input
                    type="number"
                    className="form-control"
                    value={eventForm.max_participants_per_day}
                    onChange={e => setEventForm({ ...eventForm, max_participants_per_day: parseInt(e.target.value) })}
                    min="1"
                  />
                </div>
                <div className="col-md-3 mb-3">
                  <label className="form-label">Preis (EUR)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={eventForm.price}
                    onChange={e => setEventForm({ ...eventForm, price: parseFloat(e.target.value) })}
                    min="0"
                    step="0.01"
                  />
                </div>
              </div>

              <div className="d-flex gap-2">
                <button type="submit" className="btn btn-success">Speichern</button>
                <button type="button" className="btn btn-secondary" onClick={() => setShowEventForm(false)}>Abbrechen</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {events.length === 0 ? (
        <div className="card">
          <div className="card-body text-center py-5">
            <h5>Noch keine Events</h5>
            <p className="text-muted">Erstelle ein neues Schnitzeljagd-Event, um Termine und Buchungen zu verwalten.</p>
          </div>
        </div>
      ) : (
        <div className="row">
          {events.map(event => (
            <div key={event.id} className="col-md-6 mb-4">
              <div className="card h-100">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">{event.title}</h5>
                  <span className={`badge ${event.active ? 'bg-success' : 'bg-secondary'}`}>
                    {event.active ? 'Aktiv' : 'Inaktiv'}
                  </span>
                </div>
                <div className="card-body">
                  {event.description && <p className="text-muted">{event.description}</p>}
                  <p>
                    <strong>Zeitraum:</strong> {event.start_date} bis {event.end_date}<br />
                    <strong>Max. Familien/Tag:</strong> {event.max_participants_per_day}<br />
                    <strong>Preis:</strong> {event.price > 0 ? `${parseFloat(event.price).toFixed(2)} EUR` : 'Kostenlos'}
                  </p>
                </div>
                <div className="card-footer">
                  <button
                    className="btn btn-primary me-2"
                    onClick={() => setSelectedEvent(event)}
                  >
                    Termine verwalten
                  </button>
                  <button
                    className="btn btn-outline-secondary me-2"
                    onClick={() => {
                      setEventForm(event);
                      setShowEventForm(true);
                    }}
                  >
                    Bearbeiten
                  </button>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => handleDeleteEvent(event.id)}
                  >
                    Loeschen
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
        </>
      )}
    </div>
  );
}

export default SchnitzeljagdManager;
